import gtm from 'google-tag-manager-react-router-integrator';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { GTM_CONTAINER_ID } from '../config';
import { resources, roles } from '../constants/GoogleTagManager';

const handlePageChange = (user, dataLayer) => location => {
    const { role, userId } = user || {};
    const roleDescription = get(roles, role) || roles.default;
    const resource = resources[location.pathname.match(/\/[^/]*/)[0]] || resources.default;
    dataLayer.push({
        event: 'virtualPageCV',
        PJ: 'PJ-52113',
        RL: roleDescription,
        RS: resource,
        ...(userId && { userId })
    });
};

class GoogleTagManager extends Component {
    static propTypes = {
        history: PropTypes.object,
        user: PropTypes.object
    };

    componentWillReceiveProps(nextProps) {
        const { user, history } = this.props;
        if (nextProps.user && user !== nextProps.user) {
            handlePageChange(nextProps.user, window.dataLayer)(history.location);
        }
    }

    render() {
        const { history, user } = this.props;
        if (this.gtmListener) {
            this.gtmListener();
        }
        this.gtmListener = gtm(GTM_CONTAINER_ID)(history)(handlePageChange(user, window.dataLayer));
        return null;
    }
}

function mapStateToProps(state) {
    return {
        user: state.auth.user
    };
}

function mapDispatchToProps() {
    return {};
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(GoogleTagManager));
